// @flow

import { type UserInputValidationError } from '@tectonics/prs/validation';

export function validateChileanZipcode(zipcodeValue: string): ?UserInputValidationError {
  if (!zipcodeValue || !zipcodeValue.trim())
    return { id: 'empty' };
  else if (!/^[0-9]{7}$/.test(zipcodeValue))
    return { id: 'invalid-pattern' };
}
